import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './notifications.scss';

export const notify = (type, message) => {
  switch (type) {
    case 'success':
      toast.success(message, {
        className: 'toastSuccess',
      });
      break;
    case 'error':
      toast.error(message, {
        className: 'toastError',
      });
      break;
    case 'info':
      toast.info(message, {
        className: 'toastInfo',
      });
      break;
    default:
      toast.warn(message, {
        className: 'toastWarn',
      });
      break;
  }
};

export function toastContainer() {
  return (
    <ToastContainer autoClose={4000} />
  );
}
